import classNames from "classnames";
import React from "react";

import styles from "./Content.module.scss";

interface Props {
  isActive?: boolean;
}

class Content extends React.PureComponent<Props> {
  public render() {
    const { children, isActive = false } = this.props;

    return (
      <div
        className={classNames(styles.content, { [styles.active]: isActive })}
      >
        {children}
      </div>
    );
  }
}

export default Content;
